import React, { useEffect, useId, useState } from 'react';

const EMBED_USER = 'sahil';

const MimikreeChat: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  const panelId = useId();
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const toggle = () => {
    if (!open) setMounted(true);
    setOpen((prev) => !prev);
  };

  const src =
    apiKey != null && apiKey.length > 0
      ? `https://mimikree.com/embed.html?username=${encodeURIComponent(EMBED_USER)}&apiKey=${encodeURIComponent(apiKey)}`
      : null;

  return (
    <div className={`mimikree-chat${open ? ' open' : ''}`}>
      <div
        id={panelId}
        className="mimikree-chat-panel"
        role="dialog"
        aria-label="Ask Sahil anything"
        aria-hidden={!open}
      >
        <div className="mimikree-chat-head">
          <span>ask me anything</span>
          <button
            type="button"
            className="mimikree-chat-close"
            onClick={() => setOpen(false)}
            aria-label="Close chat"
          >
            ×
          </button>
        </div>
        {mounted && src ? (
          <iframe
            title="Mimikree chat"
            src={src}
            className="mimikree-chat-frame"
            loading="lazy"
            allow="clipboard-write"
          />
        ) : open ? (
          <div className="mimikree-chat-missing">
            Chat unavailable. Set <code>REACT_APP_GOOGLE_API_KEY</code> in your{' '}
            <code>.env</code> and restart the dev server.
          </div>
        ) : null}
      </div>

      <button
        type="button"
        className="mimikree-chat-fab"
        onClick={toggle}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="mimikree-chat-fab-dot" aria-hidden />
        {open ? 'close' : 'ask me anything'}
      </button>
    </div>
  );
};

export default MimikreeChat;
